<template>
  <div>
    <v-card>
    <v-breadcrumbs :items="items" divider=">" class="py-3 pl-3"></v-breadcrumbs>
    </v-card>
  </div>
</template>
<script>
export default {
  props: ['data', 'emitSetting', 'name'],
  data: () => ({
    items: [
      {
        text: 'Settings',
        disabled: false,
        href: '#/settings/allSettings'
      }
    ],
    sameIndex: false,
    text: ''
  }),
  watch: {
    emitSetting: {
      handler () {
        console.log('items', this.items)
        console.log('emitSetting', this.emitSetting)
        this.sameIndex = false
        if (this.emitSetting !== '') {
          if (this.emitSetting === 'allSettings') {
            this.items.splice(1)
          } else {
            for (let i = 0; i < this.items.length; i++) {
              const t = this.items[i]
              if (t.text === this.name) {
                this.sameIndex = true
                this.items.splice(i + 1, 1)
              }
              t.disabled = false
            }
            if (this.sameIndex === false) {
              if (this.emitSetting === 'NewStaff') {
                let objStaffPre = {
                  text: 'Staff',
                  disabled: false,
                  href: '#/settings/staff'
                }
                this.items.splice(1, 1)
                this.items.push(objStaffPre)
              }
              if (this.emitSetting === 'leadSources' || this.emitSetting === 'leadStatuses' || this.emitSetting === 'leadQuoteSheet') {
                let objLeadPre = {
                  text: 'Lead',
                  disabled: false,
                  href: '#/settings/lead'
                }
                this.items.splice(1, 1)
                this.items.push(objLeadPre)
              }
              if (this.emitSetting === 'invoiceStatuses' || this.emitSetting === 'invoiceTax') {
                let objInvoicePre = {
                  text: 'Invoice',
                  disabled: false,
                  href: '#/settings/invoices'
                }
                this.items.splice(1, 1)
                this.items.push(objInvoicePre)
              }
              let obj = {
                text: this.name,
                disabled: true,
                href: '#/settings/' + this.emitSetting
              }
              this.items.push(obj)
            }
          }
        }
      }
    }
  }
}
</script>
<style scoped>
.disabled{
  color: grey;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/layout/components/settingBreadcrumbs.vue